import React, { useState, useEffect } from 'react';
import api from './api';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import './Doctors.css';  // if needed

const AuditLogViewer = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [usernameFilter, setUsernameFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [methodFilter, setMethodFilter] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  useEffect(() => {
    fetchAuditLogs();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [usernameFilter, statusFilter, methodFilter, fromDate, toDate, logs]);

  const fetchAuditLogs = async () => {
  
      api.get(`${process.env.REACT_APP_URL}/history/`)
         .then(response => 
          setLogs(response.data))
        .catch (err =>
          console.error('Error fetching audit logs:', err))
  }
  

  const applyFilters = () => {
    let filtered = [...logs];

    if (usernameFilter) {
      filtered = filtered.filter(log =>
        log.username.toLowerCase().includes(usernameFilter.toLowerCase())
      );
    }

    if (statusFilter) {
      filtered = filtered.filter(log => log.status === statusFilter);
    }

    if (methodFilter) {
      filtered = filtered.filter(log => log.action === methodFilter);
    }

    if (fromDate) {
      filtered = filtered.filter(log => new Date(log.timestamp) >= fromDate);
    }

    if (toDate) {
      filtered = filtered.filter(log => new Date(log.timestamp) <= toDate);
    }

    setFilteredLogs(filtered);
  };

  const columns = [
    { name: 'Time', selector: row => new Date(row.timestamp).toLocaleString(), sortable: true },
    { name: 'User', selector: row => row.username, sortable: true },
    { name: 'IP Address', selector: row => row.ipAddress || 'N/A' },
    { name: 'Method', selector: row => row.action },
    { name: 'Status', selector: row => row.status },
    {
      name: 'Endpoint',
      selector: row => row.endpoint,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Details',
      selector: row => {
        try {
          return typeof row.details === 'object'
            ? JSON.stringify(row.details)
            : row.details || 'N/A';
        } catch {
          return 'N/A';
        }
      },
      wrap: true,
      grow: 3
    },
    {
      name: 'Actions',
      button: true,
      cell: row => (
        <FaTrash
          style={{ cursor: 'pointer', color: 'red' }}
          title="Delete log"
          onClick={() => handleDeleteLog(row._id)}
        />
      )
    }

  ];

  const tableData = {
    columns,
    data: filteredLogs
  };

  const handleDeleteLog = (id) => {
  if (!window.confirm("Are you sure you want to delete this log entry?")) return;

  api.delete(`${process.env.REACT_APP_URL}/history/${id}`)
    .then(() => {
      setLogs(prev => prev.filter(log => log._id !== id));
    })
    .catch(err => {
      console.error("Error deleting log entry:", err);
      alert("Failed to delete log.");
    });
};

  return (
    <div className="audit-log-viewer">
      <h2>Audit Logs</h2>

      <div className="filter-section">
        <div className='ele'>
        <input
          type="text"
          placeholder="Username"
          value={usernameFilter}
          onChange={e => setUsernameFilter(e.target.value)}
        />

        <select value={methodFilter} onChange={e => setMethodFilter(e.target.value)}>
          <option value="">All Methods</option>
          <option value="GET">GET</option>
          <option value="POST">POST</option>
          <option value="PUT">PUT</option>
          <option value="DELETE">DELETE</option>
        </select>

        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
          <option value="">All Statuses</option>
          <option value="success">Success</option>
          <option value="failed">Failed</option>
        </select>

        <DatePicker
          selected={fromDate}
          onChange={date => setFromDate(date)}
          placeholderText="From Date"
        />
        <DatePicker
          selected={toDate}
          onChange={date => setToDate(date)}
          placeholderText="To Date"
        />
       </div>
        <button onClick={() => {
          setUsernameFilter('');
          setStatusFilter('');
          setMethodFilter('');
          setFromDate(null);
          setToDate(null);
        }}>Clear Filters</button>
      </div>

      <div className="table-section">
        <DataTableExtensions {...tableData}>
          <DataTable
            noHeader
            pagination
            highlightOnHover
            dense
            defaultSortField="timestamp"
            defaultSortAsc={false}
          />
        </DataTableExtensions>
      </div>
    </div>
  );
};

export default AuditLogViewer;
